import { gql } from "@apollo/client";

const createCoachingTopicMutation = gql`
  mutation createCoachingTopicMutation($meetingId: Int!, $title: String!) {
    createOrUpdateTopic(meetingId: $meetingId, title: $title) {
      topic {
        id
        title
      }
    }
  }
`;

export default createCoachingTopicMutation;
